function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useRefCallback, useRefGetter, useSingleton } from '@bydesign-ui/hooks';
import { useCallback, useEffect } from 'react';
import { formatDate, parseDate, parseDateArr } from '@bydesign-ui/utils';
import { CompareRangeDate, PanelType } from '../../../models/date';
export function useCompareRangeDate(options) {
  var _options$value = options.value,
      value = _options$value === void 0 ? {} : _options$value,
      format = options.format,
      locale = options.locale,
      onChange = options.onChange,
      onUpdatePanelDate = options.onUpdatePanelDate,
      onSetPanelDate = options.onSetPanelDate,
      getDefaultTargetBySource = options.getDefaultTargetBySource,
      startDay = options.startDay,
      panelType = options.panelType,
      parts = options.parts,
      extra = _objectWithoutProperties(options, ["value", "format", "locale", "onChange", "onUpdatePanelDate", "onSetPanelDate", "getDefaultTargetBySource", "startDay", "panelType", "parts"]);

  var root = useSingleton(function () {
    return new CompareRangeDate(panelType, parts);
  });
  var _value$source = value.source,
      source = _value$source === void 0 ? [] : _value$source,
      _value$isCompare = value.isCompare,
      isCompare = _value$isCompare === void 0 ? false : _value$isCompare,
      _value$target = value.target,
      target = _value$target === void 0 ? [] : _value$target;
  var onChangeCallback = useRefCallback(onChange);
  var formatGetter = useRefGetter(format == null ? locale.defaultFormat[PanelType.DATE] : format);
  var getDefaultTargetBySourceGetter = useRefGetter(getDefaultTargetBySource);
  var sourceValue = parseDateArr(source, formatGetter(), locale, panelType === PanelType.DATE);
  var targetValue = parseDateArr(target, formatGetter(), locale, panelType === PanelType.DATE);
  root.updateOptions(_objectSpread(_objectSpread({}, extra), {}, {
    startDay: startDay == null ? locale.startDay : startDay
  }));
  root.setRangePanelUpdate(onUpdatePanelDate);
  root.setSetPanelDate(onSetPanelDate);
  root.updateValue({
    source: sourceValue,
    isCompare: isCompare,
    target: targetValue
  });
  useEffect(function () {
    var callback = function callback(newVal) {
      var fn = getDefaultTargetBySourceGetter();
      onChangeCallback({
        source: newVal.source.map(function (item) {
          return formatDate(item, formatGetter(), locale);
        }),
        isCompare: newVal.isCompare,
        target: (newVal.target.length ? newVal.target : newVal.isCompare && fn ? fn(newVal.source) : []).map(function (item) {
          return formatDate(item, formatGetter(), locale);
        })
      });
    };

    root.addListener('value-change', callback);
    return function () {
      root.removeListener('value-change', callback);
      root.dispose();
    };
  }, []);
  var onSetSourcePresetTrying = useCallback(function (preset) {
    if (!preset.value.length) {
      return;
    }

    var newVal = parseDateArr(preset.value, formatGetter(), locale, panelType === PanelType.DATE);
    root.sourceRangeDate.setPresetTrying(newVal);
  }, []);
  var onCancelSourcePresetTrying = useCallback(function () {
    root.sourceRangeDate.resetPresetTrying();
  }, []);
  var onSetSourcePreset = useCallback(function (preset) {
    var newValDate = preset.value.map(function (item) {
      if (typeof item === 'string') {
        var d = parseDate(item, formatGetter(), locale);

        if (d == null) {
          throw new Error('invalid date string');
        }

        return d;
      }

      return item;
    });
    var targetNewVal = getDefaultTargetBySource ? getDefaultTargetBySource(newValDate) : [];
    onChangeCallback({
      source: newValDate.map(function (item) {
        return formatDate(item, formatGetter(), locale);
      }),
      isCompare: root.getIsCompare(),
      target: targetNewVal.map(function (item) {
        return formatDate(item, formatGetter(), locale);
      })
    });
  }, []);
  var onSetTargetPresetTrying = useCallback(function (preset) {
    if (!preset.value.length) {
      return;
    }

    var newVal = parseDateArr(preset.value, formatGetter(), locale, panelType === PanelType.DATE);
    root.targetRangeDate.setPresetTrying(newVal);
  }, []);
  var onCancelTargetPresetTrying = useCallback(function () {
    root.targetRangeDate.resetPresetTrying();
  }, []);
  var onSetTargetPreset = useCallback(function (preset) {
    var newVal = preset.value.map(function (item) {
      if (typeof item !== 'string') {
        return formatDate(item, formatGetter(), locale);
      }

      return item;
    });
    onChangeCallback({
      source: root.sourceRangeDate.getValue().map(function (item) {
        return formatDate(item, formatGetter(), locale);
      }),
      isCompare: root.getIsCompare(),
      target: newVal
    });
  }, []);
  return {
    root: root,
    onSetSourcePresetTrying: onSetSourcePresetTrying,
    onCancelSourcePresetTrying: onCancelSourcePresetTrying,
    onSetSourcePreset: onSetSourcePreset,
    onSetTargetPresetTrying: onSetTargetPresetTrying,
    onCancelTargetPresetTrying: onCancelTargetPresetTrying,
    onSetTargetPreset: onSetTargetPreset
  };
}